import { useState } from 'react'

import { ButtonText } from '@/components/common/Button'
import { LinkHash } from '@/components/common/Link'
import { LoadingMask } from '@/components/common/LoadingMask'
import { Icon } from '@/components/icons/Icon'
import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { useScrollspyActiveSlug } from '@/components/providers/ScrollspyProvider'
import { useHeightAvailable } from '@/hooks/useHeightAvailable'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'
import { cn } from '@/utils/commonUtil'

import { useGalleryGroups } from '../../GalleryGroupsProvider/GalleryGroupsProvider'

import styles from './GalleryViewRecsJumpSidebar.module.scss'

export const GalleryViewRecsJumpSidebar = () => {
  const isNavigating = useIsNavigating()
  const { groups } = useGalleryGroups()
  const activeSlug = useScrollspyActiveSlug()
  const dispatch = useReduxDispatch()
  const gallerySidebarStatus = useReduxSelector((s) => s.view.gallerySidebarStatus)
  const [isHoverSuppressed, setIsHoverSuppressed] = useState(false)
  const ref = useHeightAvailable()

  const onClickLock = () => {
    dispatch(viewActions.toggleGallerySidebar())
    setIsHoverSuppressed(true)
  }

  return (
    groups.length > 1 && (
      <aside
        className={cn(styles.container, { isHoverSuppressed, styles })}
        onMouseLeave={() => setIsHoverSuppressed(false)}
        ref={ref}
      >
        <div className={styles.inner}>
          <div className={styles.content}>
            <div className={styles.buttonLockWrap}>
              <ButtonText
                aria-label={gallerySidebarStatus === 'expanded' ? 'Unlock' : 'Lock in place'}
                onClick={onClickLock}
              >
                <span className={styles.iconUnlocked}>
                  <Icon name='arrowRightFromLine' />
                </span>
                <span className={styles.iconLocked}>
                  <Icon name='arrowLeftFromLine' />
                </span>
              </ButtonText>
            </div>
            <ul className={styles.list}>
              {groups.map(
                (group) =>
                  group.recs.length > 0 && (
                    <li className={cn(styles.item, { isCurrent: group.slug === activeSlug, styles })} key={group.slug}>
                      <LinkHash
                        analyticsEvent={{ action: 'sidebar_click', category: 'cardlists', label: group.label }}
                        aria-label={group.label}
                        className={styles.link}
                        hash={group.slug}
                      >
                        <span aria-hidden className={styles.iconWrap}>
                          <Icon name={group.icon} />
                        </span>
                        <span aria-hidden className={styles.textWrap}>
                          {group.label}
                        </span>
                      </LinkHash>
                    </li>
                  ),
              )}
              <li className={styles.item}>
                <LinkHash aria-label='Scroll to Top' className={styles.link} hash='main-content'>
                  <span aria-hidden className={styles.iconWrap}>
                    <Icon name='arrowUp' />
                  </span>
                  <span aria-hidden className={styles.textWrap}>
                    Scroll to Top
                  </span>
                </LinkHash>
              </li>
            </ul>
          </div>
          <LoadingMask loading={isNavigating} />
        </div>
      </aside>
    )
  )
}
